<template>
    <div>
        <a v-if="!showLoader" href="/logout" @click.prevent="logout">
            Logout
        </a>
        <div v-else class="loading">
            <loading-indicator />
        </div>
    </div>
</template>

<script>
    import User             from "../../Store/User";
    import LoadingIndicator from "../../../../App/Views/Components/LoadingIndicator";

    export default {
        name: "LogoutButton",

        components: { LoadingIndicator },

        data() {
            return {
                user: new User(),
                showLoader: false,
            }
        },

        methods: {
            logout() {
                this.toggleLoader();
                this.user.logout();
            },
            toggleLoader() {
                this.showLoader = !this.showLoader;
            }
        }
    }
</script>
